// extracted by mini-css-extract-plugin
export default {"main":"About_main__P67xn","aboutbox":"About_aboutbox__VrSsC","stylelg":"About_stylelg__-rIGJ","stylemb":"About_stylemb__Nuy5V"};